module.exports = __webpack_public_path__ + "static/img/bank_old2.db22352c.png";